@let emailAddress = $emailAddress();
<unity-link-shared [link]="$link()" [isHref]="true" [displayText]="emailAddress" [variants]="$variants()">
  <kendo-svg-icon class="envelope" size="large" [icon]="envelopeIcon" />
</unity-link-shared>
